import React, { useEffect, useState } from 'react';
import { publicRdvProBookingApi } from '../../lib/api';
import { Modal } from '../ui/Modal';

/**
 * « Demander une démo » : ouvre, dans le socle de modale, le widget de réservation RDV Pro du
 * super admin (le même que /rdv-pro-reserver/:id, réutilisé tel quel dans un cadre plutôt que
 * réécrit). Le bouton n'apparaît que si le super admin a activé son widget dans Compte.
 */
export const usePlatformDemo = () => {
    const [clientId, setClientId] = useState<string | null>(null);
    const [label, setLabel] = useState('Demander une démo');
    useEffect(() => {
        let cancelled = false;
        publicRdvProBookingApi.getPlatformWidget().then((data: any) => {
            if (cancelled || !data?.enabled || !data?.client_id) return;
            setClientId(String(data.client_id));
            if (data.label) setLabel(String(data.label));
        }).catch(() => { /* widget désactivé ou hors ligne : pas de bouton */ });
        return () => { cancelled = true; };
    }, []);
    return { clientId, label };
};

interface Props {
    open: boolean;
    onClose: () => void;
    clientId: string;
    title: string;
}

export const DemoRequestModal: React.FC<Props> = ({ open, onClose, clientId, title }) => (
    <Modal open={open} onClose={onClose} size="lg" title={title} subtitle="30 minutes, sans engagement — on configure votre espace avec vous." flush>
        <iframe
            src={`/rdv-pro-reserver/${encodeURIComponent(clientId)}`}
            title={title}
            className="block w-full border-0 bg-white"
            style={{ height: 'min(70vh, 720px)' }}
        />
    </Modal>
);
